<template>
  <div class="animated fadeIn">
    <b-card class="no-border animated">
      <div class="item-header clearfix mb-3">
        <h4 class="pull-left mb-0 mt-2">Set Status Shipments</h4>
      </div>
      <b-form v-on:submit.prevent="onSubmit">
        <h5>Search Shipments by State and Date</h5>
        <b-row align-h="between" class="mb-2">
          <b-col md="6">
            <label>State</label>
            <multiselect
                @input="onUpdatedState"
                name="state"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('state')}"
                v-model="selectedStateForm"
                :options="stateFrom"
                label="name"
                track-by="id"
                placeholder="Select state" class="mb-2"/>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="10">
                <label>Date Range</label>
                <br>
                <date-picker
                  :editable="false"
                  :clearable="false"
                  :shortcuts="false"
                  @input="onChangeDate($event, false)"
                  class="mx-input"
                  lang="en"
                  v-model="selectedDaterange"
                  type="date"
                  range-separator="to"
                  format="DD MMM YYYY" range>
                </date-picker>
              </b-col>
              <b-col md="2">
                <label>&nbsp;</label>
                <br>
                <b-button
                  :class="!validSelectedSearchForm ? 'disabled-button' : ''"
                  :disabled="!validSelectedSearchForm"
                  @click="searchShipment"
                  variant="primary"
                  style="height: 43px;">Search</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="form-row create-edit-shipment__form">
          <div class="form-group col-md-12" v-if="this.count_shipment > 0">
            <b-row align-h="between" class="mb-2">
              <b-col md="4">
                <label class="mb-0 pt-2">List Found Shipments (<b>{{ count_shipment }}</b>)</label>&nbsp;
                <a href="#" v-on:click.stop.prevent="onCheckAll">{{ checkAllText }}</a>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Filter"
                  label-for="filter-input"
                  label-cols-sm="3"
                  label-align-sm="right"
                  class="mb-0"
                >
                  <b-input-group>
                    <b-form-input
                      id="filter-input"
                      v-model="table.filter"
                      type="search"
                      placeholder="Type to Search"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              sticky-header no-border-collapse
              striped responsive
              :filter="table.filter"
              :items="table.items"
              :fields="table.fields">
              <template #cell(number)="data">
                <router-link :to="`/shipment_md/shipments/${data.item.id}`">{{data.value}}</router-link>
              </template>
              <template #cell(state)="data">
                {{data.value}}
              </template>
              <template #cell(delivery_date)="data">
                {{formatDate(data.value)}}
              </template>
              <template #cell(driver)="data">
                {{ get(data.item, 'driver.name', '-') }}
              </template>
              <template #cell(vehicle)="data">
                <b-form-checkbox
                  v-model="data.item.check"
                  @input="onTickCheckbox"
                  :value="data.item.id"
                >{{ get(data.item, 'vehicle.reg_no', '-') }}</b-form-checkbox>
              </template>
            </b-table>
          </div>
          <div class="form-group col-md-12" v-if="this.count_shipment === 0">
            <b-alert show variant="info">
              No available data
            </b-alert>
          </div>
        </div>
        <div class="form-row create-edit-shipment__form">
          <div class="form-group col-md-5" v-if="this.count_shipment > 0">
            <label>Total : </label>
            <h3>
              <b>{{this.countChecked}}</b> Selected Shipments
            </h3>
          </div>
          <div class="form-group col-md-5" v-if="this.count_shipment > 0">
            <label>Update State</label>
              <multiselect
                  name="stateTo"
                  v-validate="'required'"
                  :class="{'multiselect-danger': errors.has('state')}"
                  v-model="selectedStateFormTo"
                  :options="stateFrom"
                  label="name"
                  track-by="id"
                  placeholder="Select state" class="mb-2"/>
          </div>
        </div>
        <hr>
        <div v-if="this.count_shipment > 0" class="button-action-container">
          <b-button
            :class="disabledButtonSaveState ? 'disabled-button' :''"
            :disabled="disabledButtonSaveState"
            type="submit"
            variant="primary">Save changes
          </b-button>
          <b-button
            @click="onCancel()"
            type="reset"
            variant="outline-secondary"
            class="pull-right">Cancel</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import dateMixin from '@/mixins/date';
import { isEmpty, get, isArray, isNull, orderBy, omit, isObject } from 'lodash';
import { format } from 'date-fns';

export default {
  components: {
    Multiselect,
    DatePicker,
  },
  mixins: [dateMixin],
  name: 'shipment_create_edit',
  data() {
    return {
      selectedStateForm: null,
      selectedStateFormTo: null,
      selectedDaterange: null,
      customDate: null,
      formSearch: {
        state_id: '',
        start_date: '',
        end_date: '',
        state_filter_or: [],
        use_delivery_date: true,
      },
      state_filter_or: [],
      state_filter_or_to: [],
      count_shipment: null,
      detail_data: null,
      shipment_id: [],
      table: {
        fields: ['vehicle', 'driver', 'number', 'state', 'delivery_date'],
        items: [],
        filter: null,
      },
      shipment_number: [],
      stateOptions: [
        { id: 1, value: 'CREATED', name: 'Created' },
        { id: 2, value: 'READY_TO_LOAD', name: 'Ready to Load' },
        { id: 3, value: 'FINISH_LOADING', name: 'Finish Loading' },
        { id: 4, value: 'ON_PROCESS', name: 'On Process' },
        { id: 5, value: 'FINISH', name: 'Finish' },
      ],
      form: {
        state_id: '',
        start_date: '',
        end_date: '',
        id: [],
        id2: [],
        state_filter_or: [],
        loader_confirm_id: [],
        driver_confirm_id: [],
        order_confirm_id: [],
      },
      checkAllText: 'Check All',
      countChecked: 0,
      loaderConfirmId: [],
      driverConfirmId: [],
      orderConfirmId: [],
    };
  },
  created() {
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'set_status_shipment', name: 'Set Status Shipment' },
    ];
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
    this.initFromUrl();
  },
  computed: {
    stateFrom() {
      const states = this.stateOptions;
      return states;
    },
    shipments() {
      return this.table.items;
    },
    hasSelectRangeDate() {
      let hasSelectDate = true;

      if (isEmpty(this.selectedDaterange)) {
        hasSelectDate = false;
      }

      if (isArray(this.selectedDaterange)) {
        hasSelectDate = !isNull(this.selectedDaterange[0]);
      }

      return hasSelectDate;
    },
    hasSelectedStateSearch() {
      return !isEmpty(this.selectedStateForm);
    },
    validSelectedSearchForm() {
      return this.hasSelectedStateSearch && this.hasSelectRangeDate;
    },
    hasSelectedStateUpdate() {
      return !isEmpty(this.selectedStateFormTo);
    },
    disabledButtonSaveState() {
      return !this.hasSelectedStateUpdate || this.countChecked === 0;
    },
  },
  watch: {
    selectedStateForm(data) {
      this.state_filter_or = !isEmpty(data) ? data.value : '';
    },
    selectedStateFormTo(data) {
      this.form.state_id = !isEmpty(data) ? data.id : '';
      this.state_filter_or_to = !isEmpty(data) ? data.value : '';
    },
    selectedDaterange(data) {
      if (!isEmpty(data)) {
        const { form } = this;
        form.start_date = format(data[0], 'YYYY-MM-DD');
        form.end_date = format(data[1], 'YYYY-MM-DD');
      }
    },
  },
  methods: {
    initFromUrl() {
      const { query } = this.$route;
      const hasQueryState = query.state !== undefined;
      const hasQueryDate = query.date !== undefined;

      if (hasQueryState) {
        this.onUpdatedState(query.state, true);
      }

      if (hasQueryDate) {
        this.onChangeDate(query.date, true);
      }

      if (hasQueryState && hasQueryDate) {
        setTimeout(() => {
          this.searchShipment();
        }, 1e3);
      }
    },
    onUpdatedState(selectedState, fromInit = false) {
      const { query } = this.$route;
      const stateValue = isObject(selectedState) ? selectedState.value || null : selectedState;

      if (!isEmpty(selectedState)) {
        this.$router.push({
          query: {
            ...query,
            state: stateValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['state']),
          },
        });
      }

      if (fromInit) {
        this.selectedStateForm = this.stateOptions.find(dt => dt.value === stateValue);
      }
    },
    onChangeDate(date, fromInit = false) {
      const { query } = this.$route;
      const dateValue = isArray(date) ? date.map(dt => format(dt, 'YYYY-MM-DD')).join(',') : date;

      if (!isEmpty(date)) {
        this.$router.push({
          query: {
            ...query,
            date: dateValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['date']),
          },
        });
      }

      if (fromInit) {
        const dateArray = dateValue.split(',').map(dt => new Date(dt));
        this.selectedDaterange = dateArray;
      }
    },
    resetForm() {
      this.count_shipment = 0;
      this.table.items = [];
      this.selectedStateFormTo = null;
      this.checkAllText = 'Check All';
    },
    get(obj, key, defaultValue = '') {
      return get(obj, key, defaultValue);
    },
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          this.form.state_filter_or = this.state_filter_or_to;
          this.$swal({
            title: 'Confirmation',
            html: `Are you sure want to change state ? <br> For <b>${this.countChecked}</b> selected shipments`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes Update it!',
            cancelButtonText: 'No, Keep it!',
            showCloseButton: true,
            // showLoaderOnConfirm: true,
          }).then((result) => {
            if (result.value) {
              this.$store.dispatch('shipment_md/shipments/UPDATE_STATE_SHIPMENTS', this.form)
                .then(() => {
                  this.deleteConfirmation();
                  this.$swal('Updated', 'You successfully updated this file', 'success').then(() => {
                    this.searchShipment();
                    this.checkAllText = 'Check All';
                  });
                });
            } else {
              this.$swal('Cancelled', '', 'info');
            }
          });
        }
      });
    },
    deleteConfirmation() {
      this.form.loader_confirm_id = this.loaderConfirmId
        .filter((item, index) => this.loaderConfirmId.indexOf(item) === index);
      this.form.driver_confirm_id = this.driverConfirmId
        .filter((item, index) => this.driverConfirmId.indexOf(item) === index);
      this.form.order_confirm_id = this.orderConfirmId
        .filter((item, index) => this.orderConfirmId.indexOf(item) === index);

      if (this.state_filter_or === 'FINISH' && this.state_filter_or_to === 'ON_PROCESS') {
        this.$store.dispatch('shipment_md/shipments/DELETE_CONFIRMATION_DRIVER', this.form)
          .then(() => {
            this.$store.dispatch('shipment_md/shipments/DELETE_CONFIRMATION_ORDER', this.form)
              .then(() => {
                this.successDialog();
              });
          });
      } else if (this.state_filter_or === 'ON_PROCESS' && this.state_filter_or_to === 'FINISH_LOADING') {
        this.$store.dispatch('shipment_md/shipments/DELETE_CONFIRMATION_DRIVER', this.form)
          .then(() => {
            this.successDialog();
          });
      } else if (this.state_filter_or === 'FINISH_LOADING' && this.state_filter_or_to === 'READY_TO_LOAD') {
        if (!isEmpty(this.form.loader_confirm_id)) {
          this.$store.dispatch('shipment_md/shipments/DELETE_CONFIRMATION_LOADER', this.form)
            .then(() => {
              this.successDialog();
            });
        } else {
          this.successDialog();
        }
      } else if (this.state_filter_or === 'READY_TO_LOAD' && this.state_filter_or_to === 'CREATED') {
        this.successDialog();
      }
    },
    successDialog() {
      this.$swal('Updated', 'You successfully updated this file', 'success').then(() => {
        this.searchShipment();
        this.checkAllText = 'Check All';
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    searchShipment() {
      this.form.confirm_id = [];
      this.form.order_confirm_id = [];
      this.formSearch.start_date = this.form.start_date;
      this.formSearch.end_date = this.form.end_date;
      this.formSearch.state_filter_or = !isEmpty(this.state_filter_or) ?
        `${this.state_filter_or}` : '';
      return this.$store.dispatch('shipment_md/shipments/SHIPMENT_BY_STATE', this.formSearch)
        .then((data) => {
          const { shipments = [] } = data;
          const data_detail = data.detail_state[0];

          if (isEmpty(data_detail)) {
            this.count_shipment = 0;
            this.table.items = [];
            return true;
          }

          const shipmentCount = shipments.length;
          this.count_shipment = shipmentCount;
          this.table.items = orderBy(data.shipments, 'vehicle.reg_no', 'asc');
          return true;
        });
    },
    onCancel() {
      this.resetForm();
    },
    onTickCheckbox() {
      this.form.id = this.table.items
        .filter(dt => dt.check)
        .map(dt => dt.id);
      const confirmations = this.table.items
        .filter(dt => dt.check)
        .map(dt => dt.confirmations);
      confirmations.forEach((element) => {
        element.forEach((el) => {
          if (el.key === 'loader_1') {
            this.loaderConfirmId.push(el.id);
          } else {
            this.driverConfirmId.push(el.id);
          }
        });
      });
      const orders = this.table.items
        .filter(dt => dt.check)
        .map(dt => dt.orders);
      orders.forEach((element) => {
        element.forEach((el) => {
          el.confirmations.forEach((el2) => {
            this.orderConfirmId.push(el2.id);
          });
        });
      });
      const checked = this.table.items.filter(dt => dt.check) || [];
      this.countChecked = checked.length;
    },
    onCheckAll() {
      const isCheckAll = this.countChecked !== this.count_shipment;
      this.table.items = this.table.items.map((item) => {
        item.check = isCheckAll ? item.id : false;
        return item;
      });

      this.checkAllText = isCheckAll ? 'Uncheck All' : 'Check All';
    },
  },
};
</script>
<style lang="sass">
.multiselect-danger .multiselect__tags
  border: 1px solid #f86c6b

.alert
  left: 0px !important;
  position: unset !important;

.create-edit-shipment__form
  .multiselect
    z-index: 0
  .multiselect--active
    z-index: 9999
  .multiselect--active
    .multiselect__content-wrapper
      z-index: 9999 !important
</style>

<style>
.mx-datepicker.mx-input.mx-datepicker-range {
  height: 43px;
  border-radius: 0;
}

.mx-datepicker.mx-input.mx-datepicker-range > div.mx-input-wrapper > input {
  border: none;
  box-shadow: none;
}

.disabled-button {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/admin/set_status_shipment/Index.vue